export interface IUserImportLog {
  id: number;
  dateKey: string;
  type: string;
  message: string;
  resolved: boolean;
  affectedResourceId: string;
  affectedResourceName: string;
  updatedByUserMappingId: string;
  updatedBy: string;
  airportId: string;
  createdAt: Date;
}

export class UserImportLog implements IUserImportLog {
  public constructor(
    public id: number,
    public dateKey: string,
    public type: string,
    public message: string,
    public resolved: boolean,
    public affectedResourceId: string,
    public affectedResourceName: string,
    public updatedByUserMappingId: string,
    public updatedBy: string,
    public airportId: string,
    public createdAt: Date
  ) {
  }
}
